export enum ActionSubTypes {
  API_OTURUMAC = 'ast_au1',
  API_KULLANICIKONTROL = 'ast_au2',
  API_OTPAL = 'ast_au3',
  API_OTPKONTROL = 'ast_au4',
  API_SIFREMIUNUTTUM = 'ast_au5',
  API_SIFREDEGISTIR = 'ast_au6',
  API_OTURUMKAPAT = 'ast_au7',
  API_UIVERSIONKONTROL = 'ast_au8',
  API_ANASAYFAUSTBILGI = 'ast_ai1',
  API_FAALIYETALANIUSTBILGI = 'ast_ai2',
  API_GRUPSIRKETIUSTBILGI = 'ast_ai3',
  API_KIRAGENELBILGI = 'ast_ai4',
  API_KIRABILGI = 'ast_ai5',
  API_MADENSAHALARIGENELBILGI = 'ast_ai6',
  API_MADENSAHALARIBILGI = 'ast_ai7',
  API_OYAKKIRABILGILERIUSTBILGI = 'ast_ai8',
  API_OYAKKIRABILGILERIUSTBILGIKVTDETAY = 'ast_ai9',
  API_OYAKKIRABILGILERIUSTBILGIYKGDETAY = 'ast_ai10',
  API_OYAKKIRABILGILERIUSTBILGIAKGDETAY = 'ast_ai11',
  API_GRUPSIRKETDEGERLEMEUSTBILGI = 'ast_ai12',
  API_OYAKDEGERLEMEUSTBILGI = 'ast_ai13',
  API_OYAKEMLAKVERGILERI = 'ast_ai14',
  API_USTBILGIISTATISTIKDETAY = 'ast_ai15',
  API_SORGUINPUTLARI = 'ast_av1',
  API_GRUPSIRKETLISTELE = 'ast_av2',
  API_HARITADAARA = 'ast_av3',
  API_PROJELISTELE = 'ast_av4',
  API_RAPORURLGETIR = 'ast_av5',
  API_FAALIYETALANILISTESI = 'ast_av6',
  API_KULLANIMAMACLIGAYRIMENKULTOPLAMDEGER = 'ast_as1',
  API_YATIRIMAMACLIGAYRIMENKULTOPLAMDEGER = 'ast_as2',
  API_GAYRIMENKULTOPLAMDEGER = 'ast_as3',
  API_KULLANIMAMACLIGAYRIMENKULALAN = 'ast_as4',
  API_YATIRIMAMACLIGAYRIMENKULALAN = 'ast_as5',
  API_GAYRIMENKULALAN = 'ast_as6',
  API_KULLANIMAMACLIGAYRIMENKULSAYI = 'ast_as7',
  API_YATIRIMAMACLIGAYRIMENKULSAYI = 'ast_as8',
  API_GAYRIMENKULSAYI = 'ast_as9',
  API_DEGERLEMETOPLAMDEGER = 'ast_as10',
  API_YURTDISITASINMAZGENELBILGI = 'ast_as11',
  API_YURTDISITASINMAZBILGI = 'ast_as12',
  API_OYAKKIRATRGENELIKIRAYAVERILENTASINMAZLAR = 'ast_as13',
  API_OYAKGMCIROBAZLILISTE = 'ast_as14',
  API_SORGULAMASONUCLARILISTE = 'ast_as15',
  API_TIKLAMASONUCLARILISTE = 'ast_asa15',
  API_OYAKDEGERLEMETOPLAMDEGER = 'ast_as16',
  API_OYAKPROJETOPLAMHAKEDISLISTE = 'ast_as17',
  API_OYAKKIRATRGENELIYILLIKGELIRDAGILIMILISTELE = 'ast_as18',
  API_OYAKKIRATRGENELIAYLIKGELIRDAGILIMILISTELE = 'ast_as19',
  API_OYAKEMLAKVERGILERIDETAYTOPLAMDEGER = 'ast_as20',
  PAGE_DASHBOARD = 'ast_p1',
  PAGE_LOGIN = 'ast_p2',
  PAGE_KISISEL = 'ast_p3',
  PAGE_SORGULA = 'ast_p4',
  PAGE_HARITA = 'ast_p5',
  PAGE_OYAK = 'ast_p6',
  PAGE_FAALIYETALANI = 'ast_p7',
  PAGE_GRUPSIRKETI = 'ast_p8',
  PAGE_GAYRIMENKULTOPLAMDEGER = 'ast_p9',
  PAGE_GAYRIMENKULALAN = 'ast_p10',
  PAGE_GAYRIMENKULSAYI = 'ast_p11',
  PAGE_KIRABILGILERI = 'ast_p12',
  PAGE_DEGERLEMEBILGILERI = 'ast_p13',
  PAGE_TASINMAZBILGILERI = 'ast_p14',
  PAGE_MADENSAHALARI = 'ast_p15',
  PAGE_EMLAKVERGILERI = 'ast_p16',
  PAGE_PROJELER = 'ast_p17',
  PAGE_OYAKKIRABILGILERI = 'ast_p18',
  PAGE_OYAKKIRAKIRAYAVERILENTASINMAZLAR = 'ast_p19',
  PAGE_OYAKGMCIROBAZLI = 'ast_p20',
  PAGE_SORGULASONUCLARI = 'ast_sp21',
  PAGE_OYAKDEGERLEMEBILGILERI = 'ast_p22',
  PAGE_OYAKPROJETOPLAMHAKEDIS = 'ast_p23',
  PAGE_OYAKPROJEYILBAZLITOPLAMHAKEDIS = 'ast_p24',
  PAGE_OYAKPROJEAYBAZLITOPLAMHAKEDIS = 'ast_p25',
  PAGE_OYAKKIRATRGENELIYILLIKGELIRDAGILIMI = 'ast_p26',
  PAGE_OYAKKIRATRGENELIAYLIKGELIRDAGILIMI = 'ast_p27',
  PAGE_FOUROHFOUR = 'ast_p404',
  PAGE_NONEXISTS = 'ast_p999',
}
